
import React from 'react';
import { IMAGES } from '../constants';

const About: React.FC = () => {
  return (
    <section id="nosotros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="lg:w-1/2">
            <img 
              src={IMAGES.about} 
              alt="Taller DECOMAST" 
              className="rounded-2xl shadow-xl w-full object-cover aspect-video"
            />
          </div>
          <div className="lg:w-1/2">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Sobre DECOMAST</h2>
            <p className="text-slate-600 text-lg mb-6 leading-relaxed">
              En DECOMAST somos especialistas en la fabricación de mobiliario de alta gama en acero inoxidable. Con años de experiencia en el mercado peruano, nos enfocamos en combinar la ingeniería de materiales con el diseño de interiores vanguardista.
            </p>
            <p className="text-slate-600 text-lg leading-relaxed">
              Cada pieza que sale de nuestro taller es inspeccionada bajo los más altos estándares de calidad, asegurando que recibas un mueble que no solo embellezca tu hogar, sino que permanezca impecable por décadas.
            </p>
            <div className="mt-8 flex gap-4">
              <div className="text-center">
                <span className="block text-2xl font-bold text-slate-900">100%</span>
                <span className="text-xs text-slate-500 uppercase">Garantizado</span>
              </div>
              <div className="h-10 w-px bg-slate-200"></div>
              <div className="text-center">
                <span className="block text-2xl font-bold text-slate-900">Acero 304</span>
                <span className="text-xs text-slate-500 uppercase">Calidad Prime</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
